var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCadastroGerais(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-with-pencil-_1_",
    "data-name": "clipboard-with-pencil- (1)",
    transform: "translate(-1.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3073",
    "data-name": "Grupo 3073",
    transform: "translate(1.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2368",
    "data-name": "Caminho 2368",
    d: "M15.364,24.753a1.5,1.5,0,0,1-.824.545l-1.656.426a1.548,1.548,0,0,1-.4.053,1.532,1.532,0,0,1-.849-.253,1.379,1.379,0,0,1-.63-1.026l-.145-1.612a1.322,1.322,0,0,1,.259-.928l.061-.083H5.275a.82.82,0,1,1,0-1.639h7.148l1.6-2.151H5.275a.821.821,0,1,1,0-1.639l9.976-.024,3.741-5.057V7.621a1.126,1.126,0,0,0-1.156-1.112H14.972V8.646a1.874,1.874,0,0,1-1.943,1.806H7.269A1.848,1.848,0,0,1,5.354,8.646V6.509H2.46A1.147,1.147,0,0,0,1.28,7.621V26.728a1.169,1.169,0,0,0,1.18,1.14H17.835a1.149,1.149,0,0,0,1.157-1.14V19.9ZM5.275,12.656h9.746a.82.82,0,1,1,0,1.639H5.275a.82.82,0,1,1,0-1.639Z",
    transform: "translate(-1.28 -2.868)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2369",
    "data-name": "Caminho 2369",
    d: "M10.859,6.51h5.754a.769.769,0,0,0,.79-.745V2.645a.769.769,0,0,0-.79-.745h-.867a2.03,2.03,0,0,0-4.051,0h-.837a.768.768,0,0,0-.79.745V5.764A.768.768,0,0,0,10.859,6.51Zm2.863-5.452a.879.879,0,0,1,.9.842H12.817A.88.88,0,0,1,13.722,1.058Z",
    transform: "translate(-4.853)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2370",
    "data-name": "Caminho 2370",
    d: "M34.722,7.889a.529.529,0,0,0-.233-.341L33.048,6.6a.58.58,0,0,0-.32-.1.566.566,0,0,0-.458.225L22.064,20.53l2.358,1.55,10.208-13.8A.508.508,0,0,0,34.722,7.889Z",
    transform: "translate(-9.73 -2.867)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2371",
    "data-name": "Caminho 2371",
    d: "M19.354,34.772l.148,1.62a.308.308,0,0,0,.14.23.354.354,0,0,0,.19.058.331.331,0,0,0,.087-.012l1.665-.43a.338.338,0,0,0,.186-.123l.625-.845-2.359-1.551-.625.845A.293.293,0,0,0,19.354,34.772Z",
    transform: "translate(-8.628 -14.856)",
    fill: "#64c2c8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastroGerais);
export default __webpack_public_path__ + "static/media/cadastroGerais.b8ea09a89369822424d2cc55b2ddfb08.svg";
export { ForwardRef as ReactComponent };